"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var common_1 = require("../../../../../common");
var Card_1 = __importDefault(require("../../../../../common/Card/Card"));
var Modal_1 = __importDefault(require("../../../../../common/Modal/Modal"));
var org_hook_1 = require("../../../../../context/OrgContext/org.hook");
var user_hook_1 = require("../../../../../context/UserContext/user.hook");
var general_1 = require("../../../../../lib/general");
var ServiceCenterForm_1 = __importDefault(require("./ServiceCenterForm"));
var country_hook_1 = require("../../../../../context/CountryContext/country.hook");
var ServiceCenter = function (_a) {
    var data = _a.data, setCenters = _a.setCenters;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var history = (0, react_router_dom_1.useHistory)(), organization = (0, org_hook_1.useOrg)().organization, user = (0, user_hook_1.useUser)().user, country = (0, country_hook_1.useCountry)().country, currentLang = i18n.language;
    var renderChild = function (item, index) {
        return (item === null || item === void 0 ? void 0 : item.id) ? (react_1.default.createElement(Card_1.default, { text: (0, general_1.isJsonWithAvailableLang)(item.name, i18n.language, t), iconUrl: true, icon: "".concat((0, general_1.generateMediaLink)(item === null || item === void 0 ? void 0 : item.icon, organization === null || organization === void 0 ? void 0 : organization.id, country)), onClick: function () {
                history.push("/admin/service", { center: item });
            } })) : (react_1.default.createElement(Modal_1.default, { title: "add_service_center", triggerButton: react_1.default.createElement(Card_1.default, { key: t("add_fosa"), text: (0, general_1.isJsonWithAvailableLang)(item.name, i18n.language, t), iconUrl: false, icon: (item === null || item === void 0 ? void 0 : item.id) ? "organization" : "plus" }) },
            react_1.default.createElement(ServiceCenterForm_1.default, { list: data, setCenters: setCenters })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.FlatList, { data: __spreadArray([{ name: "add_fosa" }], data, true), renderItem: renderChild, numberOfColumn: 4 })));
};
exports.default = ServiceCenter;
